export const EDIT_MODE = "EDIT_MODE";
export const CREATE_MODE = "CREATE_MODE";
export type FORM_MODE = "EDIT_MODE" | "CREATE_MODE";
